export default __webpack_public_path__ + "static/media/automated-material-flow.0e66606f.svg";